module.exports = __webpack_public_path__ + "img/sprite-categories.4d38bfa.svg";